import { cn } from "@/lib/utils";

export function Switch({
	checked,
	onCheckedChange,
	disabled,
	id,
	className,
}: {
	checked: boolean;
	className?: string;
	disabled?: boolean;
	id?: string;
	onCheckedChange: (next: boolean) => void;
}) {
	return (
		<button
			aria-checked={checked}
			className={cn(
				"relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
				checked ? "bg-primary" : "bg-input",
				className
			)}
			disabled={disabled}
			id={id}
			onClick={() => onCheckedChange(!checked)}
			role="switch"
			type="button"
		>
			<span
				className={cn(
					"pointer-events-none block size-4 rounded-full bg-card shadow-sm transition-transform",
					checked ? "translate-x-4" : "translate-x-0"
				)}
			/>
		</button>
	);
}
